import { render, staticRenderFns } from "./NcpTable.vue?vue&type=template&id=3cb1839a&"
import script from "./NcpTable.vue?vue&type=script&lang=ts&"
export * from "./NcpTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports